module.exports = __webpack_public_path__ + "img/km_08.30a50968.jpeg";